import { Loader } from 'lucide-react';
import './LoadingSpinner.css';

interface LoadingSpinnerProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
}

export function LoadingSpinner({ message = 'Loading...', size = 'md' }: LoadingSpinnerProps) {
  return (
    <div className="loading-overlay">
      <div className={`loading-spinner ${size}`}>
        <Loader className="spinner-icon" />
        <p className="spinner-message">{message}</p>
      </div>
    </div>
  );
}

